module.exports = __webpack_public_path__ + "static/img/labour_dept_logo_new.fdad25a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/labour_dept_logo_new.png
// module id = rN/V
// module chunks = 0